enum AuthMethod {
  Email = 'email',
  Username = 'username',
}

export default AuthMethod;
